// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dropdown_wrapper__2oTyP","btnLink":"Dropdown_btnLink__s70Zt","disabled":"Dropdown_disabled__31KVz","menu":"Dropdown_menu__2Zr_P"};